export default "__VITE_ASSET__DpDK2bpt__";